"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _autoBind = _interopRequireDefault(require("auto-bind"));

var _marshaler = _interopRequireDefault(require("../util/marshaler"));

// Copyright © 2021 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var As = /*#__PURE__*/function () {
  function As(service) {
    (0, _classCallCheck2["default"])(this, As);
    this._api = service;
    (0, _autoBind["default"])(this);
  }

  (0, _createClass2["default"])(As, [{
    key: "encodeDownlink",
    value: function () {
      var _encodeDownlink = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(appId, deviceId, data) {
        var result;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._api.EncodeDownlink({
                  routeParams: {
                    'end_device_ids.application_ids.application_id': appId,
                    'end_device_ids.device_id': deviceId
                  }
                }, data);

              case 2:
                result = _context.sent;
                return _context.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function encodeDownlink(_x, _x2, _x3) {
        return _encodeDownlink.apply(this, arguments);
      }

      return encodeDownlink;
    }()
  }, {
    key: "decodeDownlink",
    value: function () {
      var _decodeDownlink = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(appId, deviceId, data) {
        var result;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._api.DecodeDownlink({
                  routeParams: {
                    'end_device_ids.application_ids.application_id': appId,
                    'end_device_ids.device_id': deviceId
                  }
                }, data);

              case 2:
                result = _context2.sent;
                return _context2.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function decodeDownlink(_x4, _x5, _x6) {
        return _decodeDownlink.apply(this, arguments);
      }

      return decodeDownlink;
    }()
  }, {
    key: "decodeUplink",
    value: function () {
      var _decodeUplink = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(appId, deviceId, data) {
        var result;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._api.DecodeUplink({
                  routeParams: {
                    'end_device_ids.application_ids.application_id': appId,
                    'end_device_ids.device_id': deviceId
                  }
                }, data);

              case 2:
                result = _context3.sent;
                return _context3.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function decodeUplink(_x7, _x8, _x9) {
        return _decodeUplink.apply(this, arguments);
      }

      return decodeUplink;
    }()
  }]);
  return As;
}();

var _default = As;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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